import api from './api';

export const aiApi = {
  /** Dashboard assistant chat (SellerClub metrics + agentic intents) */
  dashboardChat: async (params) => api.post('/agentic/chat', params),

  amazonMcpStatus: async (profileId) => api.get('/agentic/mcp/status', { params: { profileId } }),

  analyzeAccount: async (params) => api.post('/agentic/analyze', params),

  /** Optimization Intelligence: multi-matrix analysis + conflict-free ranked plan */
  runIntelligence: async (params) => api.post('/agentic/intelligence/run', params, { timeout: 180000 }),

  applyIntelligence: async (params) => api.post('/agentic/intelligence/apply', params),

  getIntelligenceLedger: async (params) => api.get('/agentic/intelligence/ledger', { params }),

  applyRecommendation: async (params) => api.post('/agentic/apply', params),

  /** Same apply handler for AI feature modals */
  applyAction: async (params) => api.post('/ai/apply-action', params),

  // Predictive Bid Optimization (requires server3 /api/ai proxy if enabled)
  predictOptimalBids: async (params) => api.post('/ai/predict-bids', params),

  // Anomaly Detection
  detectAnomalies: async (params) => api.post('/ai/detect-anomalies', params),

  // Smart Keyword Harvesting
  scoreSearchTerms: async (params) => api.post('/ai/score-search-terms', params),

  addKeywordsFromSearchTerms: async (params) => api.post('/ai/add-keywords', params),

  // Portfolio Budget Optimization
  optimizePortfolioBudget: async (params) => api.post('/ai/optimize-portfolio', params),

  // Performance Forecasting
  forecastPerformance: async (params) => api.post('/ai/forecast-performance', params),

  // ACOS Impact Prediction
  predictACOSImpact: async (params) => api.post('/ai/predict-acos-impact', params),

  resolveEntityBid: async (params) => api.post('/ai/resolve-entity-bid', params),

  // Get AI Statistics
  getAIStats: async (profileId) => api.get('/ai/stats', { params: { profileId } }),
};

